import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';


class Bar {
    constructor() {

        this.el = document.querySelectorAll('.swiper-slide');
        this.bar = document.querySelector('.slide-bar');
        this.indexSlide = this.el.length  - 1;
        this.dimToTrans = null;

        this.indexSlideStart = 0;

        this.finalTrans = null;

        this.valReset = null;
    }


    init() {

        const html = document.documentElement;
        const docWidth = Math.max(html['clientWidth'], html['scrollWidth'], html['offsetWidth']);

        const dimBar = this.bar.offsetWidth;
        const percBar = ( dimBar * 100 ) / docWidth;

        const percFin = 100 - percBar;
        const percSlide = percFin / this.indexSlide

        this.dimToTrans = Math.round( (docWidth / 100 ) * percSlide );

    }

    increment() {
        this.indexSlideStart = this.indexSlideStart + 1;
        this.finalTrans = this.dimToTrans * this.indexSlideStart;

        gsap.to(this.bar, 1.5, {
            x: this.finalTrans,
            ease: Power2.easeOut
        })
    }

    decrement() {
        this.indexSlideStart = this.indexSlideStart - 1;
        this.finalTrans = this.dimToTrans * this.indexSlideStart;

        gsap.to(this.bar, 1.5, {
            x: this.finalTrans,
            ease: Power2.easeOut
        })
    }

    reset(type) {
        if ( type == 'reset')
            this.indexSlideStart = 0;
        else
            this.indexSlideStart = this.indexSlide;

        this.finalTrans = this.dimToTrans * this.indexSlideStart;

        gsap.to(this.bar, 1.5, {
            x: this.finalTrans,
            ease: Power2.easeOut
        });
    }
}

export default Bar;



/** WEBPACK FOOTER **
 ** ./components/slide-bar.js
 **/